export const CHANNEL_ID_BANANA = 'banana';
export const CHANNEL_ID_WEBSITE = 'website';
export type ChannelId = typeof CHANNEL_ID_BANANA | typeof CHANNEL_ID_WEBSITE;

export const GATEWAY_SERVED_BY = 'x-gateway-servedby';
export const GRPC_PASSTHROUGH_GATEWAY_SERVED_BY = 'Grpc-Metadata-x-gateway-servedby';
export const SKYSCANNER_CHANNEL_ID = 'Grpc-Metadata-x-Skyscanner-ChannelId';
export const SKYSCANNER_DEVICE_DETECTION_IS_MOBILE =
  'Grpc-Metadata-x-Skyscanner-DeviceDetection-IsMobile';
export const SKYSCANNER_DEVICE_DETECTION_IS_TABLET =
  'Grpc-Metadata-x-Skyscanner-DeviceDetection-IsTablet';
export const SKYSCANNER_TRAVELLER_CONTEXT = 'Grpc-Metadata-x-Skyscanner-Traveller-Context';
export const SKYSCANNER_VIEW_ID = 'Grpc-Metadata-x-Skyscanner-ViewId';

export type SonarHeaders = {
  Accept: string;
  AcceptEncoding: string;
  'Content-Type': string;
  [SKYSCANNER_CHANNEL_ID]: string;
} & Partial<{
  [SKYSCANNER_DEVICE_DETECTION_IS_MOBILE]: string;
  [SKYSCANNER_DEVICE_DETECTION_IS_TABLET]: string;
  [SKYSCANNER_TRAVELLER_CONTEXT]: string;
  [SKYSCANNER_VIEW_ID]: string;
  [GRPC_PASSTHROUGH_GATEWAY_SERVED_BY]: string;
  [GATEWAY_SERVED_BY]: string;
}>;
